import React, { useState, useEffect, useRef } from 'react';
import { Card } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser } from '@fortawesome/free-solid-svg-icons';
import { constr_uri } from '../../../services/apiClient';
import { employeeAPI } from './components/Employee/actions';
import { MemberModal } from './components/Team/TeamGallery';


const DAYS_UK = {
  monday: 'Пн',
  tuesday: 'Вт',
  wednesday: 'Ср',
  thursday: 'Чт',
  friday: 'Пт',
  saturday: 'Сб',
  sunday: 'Нд',
};

const DAY_ORDER = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];

function formatDays(days) {
  // Сортуємо за порядком днів тижня
  const sorted = [...days].sort((a, b) => DAY_ORDER.indexOf(a) - DAY_ORDER.indexOf(b));

  // Групуємо в безперервні діапазони
  const ranges = [];
  let start = sorted[0];
  let prev = sorted[0];

  for (let i = 1; i <= sorted.length; i++) {
    const curr = sorted[i];
    const prevIndex = DAY_ORDER.indexOf(prev);
    const currIndex = DAY_ORDER.indexOf(curr);

    if (currIndex === prevIndex + 1) {
      prev = curr;
    } else {
      ranges.push(start === prev ? DAYS_UK[start] : `${DAYS_UK[start]}-${DAYS_UK[prev]}`);
      start = curr;
      prev = curr;
    }
  }

  return ranges.join(', ');
}

const KindergartenInfo = ({kindergartenData}) => {

    // Директор явно обирається зі списку працівників у "Паспорті ЗДО"
    // (head.employeeId) — там же, де редагується його ПІБ.
    const [directorEmployee, setDirectorEmployee] = useState(null);
    const directorCardRef = useRef(null);
    const [directorModalRect, setDirectorModalRect] = useState(null);

    useEffect(() => {
      const kgId = kindergartenData && kindergartenData._id;
      const employeeId = kindergartenData && kindergartenData.head && kindergartenData.head.employeeId;
      if (!kgId || !employeeId) { setDirectorEmployee(null); return; }

      let cancelled = false;
      employeeAPI.getEmployeeById(kgId, employeeId)
        .then(emp => {
          if (cancelled) return;
          setDirectorEmployee(emp || null);
        })
        .catch(error => {
          console.error('Помилка завантаження картки директора:', error);
          if (!cancelled) setDirectorEmployee(null);
        });

      return () => { cancelled = true; };
    }, [kindergartenData && kindergartenData._id, kindergartenData && kindergartenData.head && kindergartenData.head.employeeId]);

    const getAdjustedRect = (rect) => ({
      top: rect.top - window.scrollY,
      left: rect.left - window.scrollX,
      width: rect.width,
      height: rect.height,
    });

    const handleDirectorClick = () => {
      if (!directorEmployee || !directorCardRef.current) return;
      const rect = directorCardRef.current.getBoundingClientRect();
      setDirectorModalRect({
        top: rect.top + window.scrollY,
        left: rect.left + window.scrollX,
        width: rect.width,
        height: rect.height,
      });
    };

    const directorMember = directorEmployee ? {
      id: directorEmployee._id,
      fullName: directorEmployee.fullName ||
        [directorEmployee.lastName, directorEmployee.firstName, directorEmployee.middleName].filter(Boolean).join(' '),
      position: (directorEmployee.publicProfile && directorEmployee.publicProfile.publicPosition) ||
        (directorEmployee.departments && (directorEmployee.departments.find(d => d.selected) || directorEmployee.departments[0])?.positionName) ||
        'Директор',
      photoDocId: directorEmployee.photoDocId,
      avatarFileId: (directorEmployee.publicProfile && directorEmployee.publicProfile.avatarFileId) || directorEmployee.photos?.[0]?.id,
      bio: (directorEmployee.publicProfile && directorEmployee.publicProfile.bio) || '',
      displayGroup: 1 // "Керівництво"
    } : null;

    return (
            <Card className="contact-card">
              <Card.Body>
                <h3 className="contact-title">Контакти</h3>
                
                <div className="contact-item">
                  <div className="contact-label">Адреса</div>
                  <div className="contact-value">{kindergartenData.contacts.address.string}</div>
                </div>

                <div className="contact-item">
                  <div className="contact-label">Район</div>
                  <div className="contact-value">{kindergartenData.contacts.address.district}</div>
                </div>

                <div className="contact-item">
                  <div className="contact-label">Директор</div>
                  <div
                    ref={directorCardRef}
                    className="contact-value"
                    onClick={handleDirectorClick}
                    style={directorEmployee ? {
                      display: 'inline-flex', alignItems: 'center', gap: 8, cursor: 'pointer'
                    } : undefined}
                  >
                    {directorEmployee && (
                      <span style={{
                        width: 28, height: 28, borderRadius: '50%', overflow: 'hidden',
                        background: '#dee2e6', flexShrink: 0,
                        display: 'inline-flex', alignItems: 'center', justifyContent: 'center'
                      }}>
                        {directorMember.photoDocId && directorMember.avatarFileId ? (
                          <img
                            src={constr_uri(`docfile?doc_id=${directorMember.photoDocId}&file_id=${directorMember.avatarFileId}`)}
                            alt=""
                            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                          />
                        ) : (
                          <FontAwesomeIcon icon={faUser} style={{ color: '#adb5bd', fontSize: 12 }} />
                        )}
                      </span>
                    )}
                    <span>{kindergartenData.head.firstName} {kindergartenData.head.middleName} {kindergartenData.head.lastName}</span>
                  </div>
                </div>

                {directorModalRect && directorMember && (
                  <div onClick={(e) => e.stopPropagation()}>
                    <MemberModal
                      members={[directorMember]}
                      startIndex={0}
                      originRect={getAdjustedRect(directorModalRect)}
                      onClose={() => setDirectorModalRect(null)}
                    />
                  </div>
                )}

                <div className="contact-item">
                  <div className="contact-label">Телефон</div>
                  <div className="contact-value">
                    {kindergartenData.contacts.phones.map((phone, index) => (
                      <span key={index}>
                        <a href={`tel:${phone}`}>{phone}</a>
                        {index < kindergartenData.contacts.phones.length - 1 && ', '}
                      </span>
                    ))}
                  </div>
                </div>

                <div className="contact-item">
                  <div className="contact-label">E-mail</div>
                  <div className="contact-value">
                    <a href={`mailto:${kindergartenData.contacts.email}`}>
                      {kindergartenData.contacts.email}
                    </a>
                  </div>
                </div>

               

                <div className="contact-item">
                  <div className="contact-label">Сайт</div>
                  <div className="contact-value">
                    <a href={kindergartenData.contacts.site} target="_blank" rel="noopener noreferrer">
                      {kindergartenData.contacts.site}
                    </a>
                  </div>
                </div>

                {/* Schedule Section */}
                <div className="schedule-section">
                  <h4 className="schedule-title">Режим роботи</h4>
                  
                  
                    <div key="schedule-item" className="schedule-item">
                      <div className="schedule-day">{formatDays(kindergartenData.workingHours.daysOfWeek) || "Пн-Пт"}</div>
                      <div className="schedule-time">{kindergartenData.workingHours.timeFrom}-{kindergartenData.workingHours.timeTo}</div>
                    </div>
                  
                </div>

                <div className="schedule-section">
                  <h4 className="schedule-title">Чи надсилаються запрошення:</h4>
                  <div className="contact-value">
                    {kindergartenData.state_open ? 'Так, відкритий на прийом' : 'Ні, тимчасово закритий на прийом'}
                  </div>
                </div>


                {/* Additional Info */}
                <div className="additional-info">
                  <h4 className="additional-title">Спеціалізація</h4>
                  <p className="additional-text">{kindergartenData.specialization}</p>

                  <h4 className="additional-title">Додаткові сервіси</h4>
                  <p className="additional-text">{kindergartenData.additionalServices && kindergartenData.additionalServices.entity || "Не має"}</p>

                  <h4 className="additional-title">Тип закладу</h4>
                  <p className="additional-text">{kindergartenData.specifics}</p>

                  <h4 className="additional-title">У нас є</h4>
                  <p className="additional-text">{kindergartenData.existence && [kindergartenData.existence].join(", ") || ''}</p>
                </div>
              </Card.Body>
            </Card>
    )

}

export default KindergartenInfo;